// import React from 'react';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import TableSkeleton from '../widgets/TableSkeleton';
// import NoDataPlaceholder from '../NoDataPlaceholder';
// import { Checkbox, TablePagination, useTheme } from '@mui/material';
// import { Link } from 'react-router-dom';
// import { useState } from 'react';
// const StoneTableViewWIthAGRFormat = ({ Stoneresultdata,SelectedStone,setSelectedStone,setStoneresultdata,isedit=false  }) => {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(50); // Change the number of rows per page as needed

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const emptyRows = rowsPerPage - Math.min(rowsPerPage, Stoneresultdata?.length - page * rowsPerPage);

//   const handleStoneSelect = (stone) => {
//     console.log(stone);
//     if (SelectedStone.indexOf(stone) === -1) {
//       // If the stone is not in SelectedStone, add it
//       setSelectedStone([...SelectedStone, stone]);
//     } else {
//       // If the stone exists in SelectedStone, remove it
//       const updatedStones = SelectedStone.filter((s) => s !== stone);
//       setSelectedStone(updatedStones);
//     }
//   };
//   const theme = useTheme();
//   const InfoStyle = {
//     background: theme.palette.info.main,
//     color: '#fff',
//     textAlign: 'center',
//   };
//   const GreenStyle = {
//     background: 'green',
//     color: '#fff',
//     textAlign: 'center',
//   };
//   const RedStyle = {
//     background: theme.palette.error.main,
//     color: '#fff',
//     textAlign: 'center',
//   };

//   return (
//    <>
//    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
//     <TableContainer sx={{ maxHeight: '80vh' }}>
//       {Stoneresultdata== null? <TableSkeleton/>:Stoneresultdata.length >0 ?<Table stickyHeader  sx={{ minWidth: 650 }}  size='small' aria-label="simple table">
//         <TableHead >
//           <TableRow>
//             <TableCell><Checkbox onClick={(e)=>{
//               if(e.target.checked){
//                 let stondata = Stoneresultdata?.map((row,index) => row.STONE)
//                 stondata ? setSelectedStone(stondata) : setSelectedStone([])
//               } else{
//                 setSelectedStone([])
//               }
//             }} /></TableCell>
//             <TableCell align="center">Party</TableCell>
//             <TableCell align="center">Status</TableCell>
//             <TableCell align="center">StoneId</TableCell>
//             <TableCell align="center">Lab</TableCell>
//             <TableCell align="center">ReportNO</TableCell>
//             <TableCell align="center">Shape</TableCell>
//             <TableCell align="center">Carats</TableCell>
//             <TableCell align="center">Color</TableCell>
//             <TableCell align="center">Clarity</TableCell>
//             <TableCell align="center">Rap($)</TableCell>
//             <TableCell align="center" sx={InfoStyle}>Disc(%)</TableCell>
//             <TableCell align="center" sx={InfoStyle}>AMT/CTS($)</TableCell>
//             <TableCell align="center" sx={InfoStyle}>AMT($)</TableCell>
//             <TableCell align="center" sx={GreenStyle}>Disc(%)</TableCell>
//             <TableCell align="center" sx={GreenStyle}>AMT/CTS($)</TableCell>
//             <TableCell align="center"sx={GreenStyle}>AMT($)</TableCell>
//             <TableCell align="center" sx={RedStyle}>Disc(%)</TableCell>
//             <TableCell align="center" sx={RedStyle}>AMT/CTS($)</TableCell>
//             <TableCell align="center"sx={RedStyle}>AMT($)</TableCell>
//             <TableCell align="center">Table(%)</TableCell>
//             <TableCell align="center">Depth(%)</TableCell>
//             <TableCell align="center">Measurement</TableCell>
//             <TableCell align="center">Cut</TableCell>
//             <TableCell align="center">Polish</TableCell>
//             <TableCell align="center">Symm</TableCell>
//             <TableCell align="center">Image</TableCell>
//             <TableCell align="center">Video</TableCell>
//             {/* <TableCell align="right">Calories</TableCell>
//             <TableCell align="right">Carbs&nbsp;(g)</TableCell>
//             <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
//           </TableRow>
//         </TableHead>
//         <TableBody>
//         {Stoneresultdata
//           ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//           .map((row,index) => (
//             <TableRow
//               key={row.STONE}
//               sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//             >
//               <TableCell component="th" scope="row"><Checkbox checked={SelectedStone.includes(row.STONE)} onClick={()=> handleStoneSelect(row.STONE)}/></TableCell>
//               {/* <TableCell align="right">{index+1}</TableCell> */}
//               <TableCell align="right">{row.PARTY|| '-'}</TableCell>
//               <TableCell align="right">{row.STATUS}</TableCell>
//               {/* <TableCell align="right">{row.FL_BRID}</TableCell> */}
//               <TableCell align="right">{row.STONE}</TableCell>
//               <TableCell align="right">{row.LAB}</TableCell>
//               <TableCell align="right">{row.REPORTNO}</TableCell>
//               <TableCell align="right">{row.SHAPE}</TableCell>
//               <TableCell align="right">{row.CARATS}</TableCell>
//               <TableCell align="right">{row.COLOR}</TableCell>
//               <TableCell align="right">{row.CLARITY}</TableCell>
//               <TableCell align="right">{row.RAP_PRICE}</TableCell>
//               <TableCell align="right" sx={InfoStyle}>{row.ASK_DISC.toFixed(2)}</TableCell>
//               <TableCell align="right" sx={InfoStyle}>{((row.RAP_PRICE-(row.RAP_PRICE * row.ASK_DISC / 100))).toFixed(2)}</TableCell>
//               <TableCell align="right" sx={InfoStyle}>{((row.RAP_PRICE-(row.RAP_PRICE * row.ASK_DISC / 100)) * row.CARATS).toFixed(2)}</TableCell>
//               <TableCell align="right" sx={GreenStyle}>{row.GREEN_DISC.toFixed(2)}</TableCell>
//               <TableCell align="right" sx={GreenStyle}>{((row.RAP_PRICE-(row.RAP_PRICE * row.GREEN_DISC / 100))).toFixed(2)}</TableCell>
//               <TableCell align="right" sx={GreenStyle}>{((row.RAP_PRICE-(row.RAP_PRICE * row.GREEN_DISC / 100)) * row.CARATS).toFixed(2)}</TableCell>
//               <TableCell align="right" sx={RedStyle}>{row.RED_DISC.toFixed(2)}</TableCell>
//               <TableCell align="right" sx={RedStyle}>{((row.RAP_PRICE-(row.RAP_PRICE * row.RED_DISC / 100))).toFixed(2)}</TableCell>
//               <TableCell align="right" sx={RedStyle}>{((row.RAP_PRICE-(row.RAP_PRICE * row.RED_DISC / 100)) * row.CARATS).toFixed(2)}</TableCell>
//               <TableCell align="right">{row.FL_TABLE_PER}</TableCell>
//               <TableCell align="right">{row.FL_DEPTH_PER}</TableCell>
//               <TableCell align="right">{row.FL_MEASUREMENTS}</TableCell>
//               <TableCell align="right">{row.CUT}</TableCell>
//               <TableCell align="right">{row.POLISH}</TableCell>
//               <TableCell align="right">{row.SYMM}</TableCell>
//               <TableCell align="right"> <Link component="button" to={`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/${row.STONE}/still.jpg`} target='_blank'>Image</Link></TableCell>
//               <TableCell align="right"> <Link component="button" to={`https://kind-pebble-01609c310.3.azurestaticapps.net/detail/${row.STONE}/?ic=1`} target='_blank'>Video</Link></TableCell>
//             </TableRow>
//           ))}
//         </TableBody>

//       </Table> : <NoDataPlaceholder/>}
//     </TableContainer></Paper> <TablePagination
//         rowsPerPageOptions={[50, 100, 500]}
//         component="div"
//         count={Stoneresultdata?.length || 0}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onPageChange={handleChangePage}
//         onRowsPerPageChange={handleChangeRowsPerPage}
//       /></>
//   )
// };

// export default StoneTableViewWIthAGRFormat;
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Checkbox,
  Divider,
  Link,
  Paper,
  Stack,
  TextField,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@emotion/react";
import NoDataPlaceholder from "../NoDataPlaceholder";
import TableSkeleton from "../widgets/TableSkeleton";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import styled from "@emotion/styled";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { useEffect } from "react";
import { isMobileDevice } from "app/utils/modifyArrayOfObjectsKeys";
const useStyles = makeStyles((theme) => ({
  RedCell: { background: theme.palette.error.main, color: "#fff" },
  GreenCell: { background: "green", color: "#fff" },
  ASkCell: { background: theme.palette.info.main, color: "#fff" },
}));
const StoneTableViewWithAGRFormat = ({
  Stoneresultdata,
  SelectedStone,
  setSelectedStone,
  selectedStoneDetails,
  Fl_red_flg = 0,
  setStoneresultdata,
  isedit = false,
  page,
  pageSize,
  rowCount,
  loading,
  handlePageSizeChange,
  // handlePageChange,
  // handlePageSizeChange,
}) => {
  const classes = useStyles();
  const [columns, setColumns] = React.useState([
    {
      field: "PARTY",
      headerName: "Party",
      width: 70,
      headerClassName: "TopHeader",
      renderCell: (params) => (params.value == " ()" ? "-" : params.value),
    },
    {
      field: "STATUS",
      headerName: "Status",
      width: 40,
      renderCell: (params) => params.value[0] || "",
    },
    { field: "STONE", headerName: "StoneId", width: 100 },
    { field: "FL_BRID", headerName: "Location", width: 180 },
    { field: "LAB", headerName: "Lab", width: 10 },
    { field: "REPORTNO", headerName: "ReportNO", width: 100 },
    { field: "SHAPE", headerName: "Shape", width: 120 },
    {
      field: "CARATS",
      headerName: "Carats",
      width: 80,
      type: "number",
      renderCell: ({ value }) => value?.toFixed(2),
    },
    { field: "COLOR", headerName: "Color", width: 50 },
    { field: "CLARITY", headerName: "Clarity", width: 60 },
    {
      field: "RAP_PRICE",
      headerName: "Rap($)",
      width: 100,
      renderCell: (params) => Number(params.value).toFixed(2),
    },
    {
      field: "ASK_DISC",
      headerName: "Disc(%)",
      width: 60,
      renderCell: (params) => Number(params.value)?.toFixed(2),
      cellClassName: classes.ASkCell,
    },
    {
      field: "ASK_DISC_PER_CTS",
      headerName: "AMT/CTS($)",
      width: 100,
      renderCell: (params) =>
        (
          Number(params.row.RAP_PRICE) -
          (Number(params.row.RAP_PRICE) * params.row.ASK_DISC) / 100
        )?.toFixed(2),
      cellClassName: classes.ASkCell,
    },
    {
      field: "ASK_DISC_AMT",
      headerName: "AMT($)",
      width: 100,
      renderCell: (params) =>
        (
          (Number(params.row.RAP_PRICE) -
            (Number(params.row.RAP_PRICE) * params.row.ASK_DISC) / 100) *
          params.row.CARATS
        )?.toFixed(2),
      cellClassName: classes.ASkCell,
    },
    {
      field: "ASK_DISC_AMTRmB",
      headerName: "AMT(RMB)",
      width: 100,
      valueGetter: (params) =>
        `${(
          jumboco?.curr?.Rate *
          ((Number(params.row.RAP_PRICE) -
            (Number(params.row.RAP_PRICE) * params.row.ASK_DISC) / 100) *
            params.row.CARATS)
        ).toFixed(2)}`,
      cellClassName: classes.ASkCell,
    },
    {
      field: "GREEN_DISC",
      headerName: "G Disc(%)",
      width: 80,
      renderCell: (params) => Number(params.value)?.toFixed(2),
      cellClassName: classes.GreenCell,
    },
    {
      field: "GREEN_DISC_PER_CTS",
      headerName: "G AMT/CTS($)",
      width: 100,
      renderCell: (params) =>
        (
          Number(params.row.RAP_PRICE) -
          (Number(params.row.RAP_PRICE) * params.row.GREEN_DISC) / 100
        )?.toFixed(2),
      cellClassName: classes.GreenCell,
    },
    {
      field: "GREEN_DISC_AMT",
      headerName: "G AMT($)",
      width: 100,
      renderCell: (params) =>
        (
          (Number(params.row.RAP_PRICE) -
            (Number(params.row.RAP_PRICE) * params.row.GREEN_DISC) / 100) *
          params.row.CARATS
        )?.toFixed(2),
      cellClassName: classes.GreenCell,
    },
    {
      field: "GREEN_DISC_AMT_rmb",
      headerName: "G AMT(RMB)",
      width: 100,
      renderCell: (params) =>
        (
          jumboco?.curr?.Rate *
          ((Number(params.row.RAP_PRICE) -
            (Number(params.row.RAP_PRICE) * params.row.GREEN_DISC) / 100) *
            params.row.CARATS)
        )?.toFixed(2),
      cellClassName: classes.GreenCell,
    },
    // {
    //   field: 'RED_DISC',
    //   headerName: 'R Disc(%)',
    //   width: 80,
    //   headerClassName:{
    //     background: 'red',
    //     color: '#fff',
    //     textAlign: 'center',
    //   },
    //   renderCell: (params) => (
    //     Number(params.value)?.toFixed(2)
    //   ),
    //   cellClassName: classes.RedCell
    // },
    // {
    //   field: 'RED_DISC_PER_CTS',
    //   headerName: 'R AMT/CTS($)',
    //   width: 100,
    //   headerClassName:{
    //     background: 'red',
    //     color: '#fff',
    //     textAlign: 'center',
    //   },
    //   renderCell: (params) => (
    //     ((Number(params.row.RAP_PRICE) - (Number(params.row.RAP_PRICE) * params.row.RED_DISC / 100)))?.toFixed(2)
    //   ),
    //   cellClassName: classes.RedCell
    // },
    // {
    //   field: 'RED_DISC_AMT',
    //   headerName: 'R AMT($)',
    //   width: 100,
    //   headerClassName:{
    //     background: 'red',
    //     color: '#fff',
    //     textAlign: 'center',
    //   },
    //   renderCell: (params) => (
    //     ((Number(params.row.RAP_PRICE) - (Number(params.row.RAP_PRICE) * params.row.RED_DISC / 100)) * params.row.CARATS)?.toFixed(2)
    //   ),
    //   cellClassName: classes.RedCell
    // },
    // {
    //   field: 'RED_DISC_RMB',
    //   headerName: 'R AMT(RMB)',
    //   width: 100,
    //   headerClassName:{
    //     background: 'red',
    //     color: '#fff',
    //     textAlign: 'center',
    //   },
    //   renderCell: (params) => (
    //      (jumboco?.curr?.Rate * (Number(params.row.RAP_PRICE) - (Number(params.row.RAP_PRICE) * params.row.RED_DISC / 100)) * params.row.CARATS)?.toFixed(2)
    //   ),
    //   cellClassName: classes.RedCell
    // },
    { field: "FL_TABLE_PER", headerName: "Table(%)", width: 60 },
    { field: "FL_DEPTH_PER", headerName: "Depth(%)", width: 60 },
    { field: "FL_MEASUREMENTS", headerName: "Measurement", width: 100 },
    { field: "CUT", headerName: "Cut", width: 50 },
    { field: "POLISH", headerName: "Polish", width: 50 },
    { field: "SYMM", headerName: "Symm", width: 50 },
    { field: "FL_REPORTCOMMENT", headerName: "Comment", width: 250 },
    {
      field: "Image",
      headerName: "Image",
      width: 60,
      renderCell: (params) => (
        <Link
          component="button"
          onClick={(e) => {
            e.stopPropagation();
            window.open(
              `https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`
            );
          }}
          href={`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/${params.row.STONE}/still.jpg`}
          target="_blank"
        >
          Image
        </Link>
      ),
    },
    {
      field: "Video",
      headerName: "Video",
      width: 60,
      renderCell: (params) => (
        <Link
          onClick={(e) => {
            e.stopPropagation();
            window.open(
              `https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`
            );
          }}
          component="button"
          href={`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`}
          target="_blank"
        >
          Video
        </Link>
      ),
    },
  ]);
  // const handlePageChange = (newPage) => {
  //   console.log("Page changed to:", newPage);
  //   //  setPage(newPage);
  // };

  // const handlePageSizeChange = (newPageSize) => {
  //   console.log("Page size changed to:", newPageSize);
  //   //setPageSize(newPageSize);
  // };

  const [discVal, setDiscVal] = React.useState(null);
  const [rowsPerPage, setRowsPerPage] = React.useState([50, 100, 500, 1000]);
  const isMobile = isMobileDevice();

  useEffect(() => {
    Fl_red_flg == 1 &&
      setColumns([
        {
          field: "PARTY",
          headerName: "Party",
          width: 70,
          headerClassName: "TopHeader",
          renderCell: (params) => (params.value == " ()" ? "-" : params.value),
        },
        {
          field: "STATUS",
          headerName: "Status",
          width: 40,
          renderCell: (params) => params.value[0] || "",
        },
        { field: "STONE", headerName: "StoneId", width: 100 },
        { field: "FL_BRID", headerName: "Location", width: 180 },
        { field: "LAB", headerName: "Lab", width: 10 },
        { field: "REPORTNO", headerName: "ReportNO", width: 100 },
        { field: "SHAPE", headerName: "Shape", width: 120 },
        { field: "CARATS", headerName: "Carats", width: 80 },
        { field: "COLOR", headerName: "Color", width: 50 },
        { field: "CLARITY", headerName: "Clarity", width: 60 },
        {
          field: "RAP_PRICE",
          headerName: "Rap($)",
          width: 100,
          renderCell: (params) => Number(params.value).toFixed(2),
        },
        {
          field: "ASK_DISC",
          headerName: "Disc(%)",
          width: 60,
          renderCell: (params) => Number(params.value)?.toFixed(2),
          cellClassName: classes.ASkCell,
        },
        {
          field: "ASK_DISC_PER_CTS",
          headerName: "AMT/CTS($)",
          width: 100,
          renderCell: (params) =>
            (
              Number(params.row.RAP_PRICE) -
              (Number(params.row.RAP_PRICE) * params.row.ASK_DISC) / 100
            )?.toFixed(2),
          cellClassName: classes.ASkCell,
        },
        {
          field: "ASK_DISC_AMT",
          headerName: "AMT($)",
          width: 100,
          renderCell: (params) =>
            (
              (Number(params.row.RAP_PRICE) -
                (Number(params.row.RAP_PRICE) * params.row.ASK_DISC) / 100) *
              params.row.CARATS
            )?.toFixed(2),
          cellClassName: classes.ASkCell,
        },
        {
          field: "ASK_DISC_AMTRmB",
          headerName: "AMT(RMB)",
          width: 100,
          valueGetter: (params) =>
            `${(
              jumboco?.curr?.Rate *
              ((Number(params.row.RAP_PRICE) -
                (Number(params.row.RAP_PRICE) * params.row.ASK_DISC) / 100) *
                params.row.CARATS)
            ).toFixed(2)}`,
          cellClassName: classes.ASkCell,
        },
        {
          field: "GREEN_DISC",
          headerName: "G Disc(%)",
          width: 80,
          renderCell: (params) => Number(params.value)?.toFixed(2),
          cellClassName: classes.GreenCell,
        },
        {
          field: "GREEN_DISC_PER_CTS",
          headerName: "G AMT/CTS($)",
          width: 100,
          renderCell: (params) =>
            (
              Number(params.row.RAP_PRICE) -
              (Number(params.row.RAP_PRICE) * params.row.GREEN_DISC) / 100
            )?.toFixed(2),
          cellClassName: classes.GreenCell,
        },
        {
          field: "GREEN_DISC_AMT",
          headerName: "G AMT($)",
          width: 100,
          renderCell: (params) =>
            (
              (Number(params.row.RAP_PRICE) -
                (Number(params.row.RAP_PRICE) * params.row.GREEN_DISC) / 100) *
              params.row.CARATS
            )?.toFixed(2),
          cellClassName: classes.GreenCell,
        },
        {
          field: "GREEN_DISC_AMT_rmb",
          headerName: "G AMT(RMB)",
          width: 100,
          renderCell: (params) =>
            (
              jumboco?.curr?.Rate *
              ((Number(params.row.RAP_PRICE) -
                (Number(params.row.RAP_PRICE) * params.row.GREEN_DISC) / 100) *
                params.row.CARATS)
            )?.toFixed(2),
          cellClassName: classes.GreenCell,
        },
        {
          field: "RED_DISC",
          headerName: "R Disc(%)",
          width: 80,
          headerClassName: {
            background: "red",
            color: "#fff",
            textAlign: "center",
          },
          renderCell: (params) => Number(params.value)?.toFixed(2),
          cellClassName: classes.RedCell,
        },
        {
          field: "RED_DISC_PER_CTS",
          headerName: "R AMT/CTS($)",
          width: 100,
          headerClassName: {
            background: "red",
            color: "#fff",
            textAlign: "center",
          },
          renderCell: (params) =>
            (
              Number(params.row.RAP_PRICE) -
              (Number(params.row.RAP_PRICE) * params.row.RED_DISC) / 100
            )?.toFixed(2),
          cellClassName: classes.RedCell,
        },
        {
          field: "RED_DISC_AMT",
          headerName: "R AMT($)",
          width: 100,
          headerClassName: {
            background: "red",
            color: "#fff",
            textAlign: "center",
          },
          renderCell: (params) =>
            (
              (Number(params.row.RAP_PRICE) -
                (Number(params.row.RAP_PRICE) * params.row.RED_DISC) / 100) *
              params.row.CARATS
            )?.toFixed(2),
          cellClassName: classes.RedCell,
        },
        {
          field: "RED_DISC_RMB",
          headerName: "R AMT(RMB)",
          width: 100,
          headerClassName: {
            background: "red",
            color: "#fff",
            textAlign: "center",
          },
          renderCell: (params) =>
            (
              jumboco?.curr?.Rate *
              (Number(params.row.RAP_PRICE) -
                (Number(params.row.RAP_PRICE) * params.row.RED_DISC) / 100) *
              params.row.CARATS
            )?.toFixed(2),
          cellClassName: classes.RedCell,
        },
        { field: "FL_TABLE_PER", headerName: "Table(%)", width: 60 },
        { field: "FL_DEPTH_PER", headerName: "Depth(%)", width: 60 },
        { field: "FL_MEASUREMENTS", headerName: "Measurement", width: 100 },
        { field: "CUT", headerName: "Cut", width: 50 },
        { field: "POLISH", headerName: "Polish", width: 50 },
        { field: "SYMM", headerName: "Symm", width: 50 },
        { field: "FL_REPORTCOMMENT", headerName: "Comment", width: 250 },
        {
          field: "Image",
          headerName: "Image",
          width: 60,
          renderCell: (params) => (
            <Link
              component="button"
              onClick={(e) => {
                e.stopPropagation();
                window.open(
                  `https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`
                );
              }}
              href={`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/${params.row.STONE}/still.jpg`}
              target="_blank"
            >
              Image
            </Link>
          ),
        },
        {
          field: "Video",
          headerName: "Video",
          width: 60,
          renderCell: (params) => (
            <Link
              onClick={(e) => {
                e.stopPropagation();
                window.open(
                  `https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`
                );
              }}
              component="button"
              href={`https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=${params.row.STONE}&ic=1`}
              target="_blank"
            >
              Video
            </Link>
          ),
        },
      ]);
  }, [Fl_red_flg]);
  const theme = useTheme();

  const jumboco = useJumboAuth();
  // const columns = ;
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  const handleSelectionModelChange = (newSelectionModel) => {
    setSelectedStone(newSelectionModel);
    // Do something with the selected rows (in this case, log them)
  };
  const DiscountStoneHandler = () => {
    // console.log(SelectedStone);
    let StoneData = Stoneresultdata.filter((s) =>
      SelectedStone.includes(s.STONE)
    );
    let StoneDataWitout = Stoneresultdata.filter(
      (s) => !SelectedStone.includes(s.STONE)
    );
    let stoneWithUpdate = StoneData.map((data) => ({
      ...data,
      ASK_DISC:
        Number(data.ASK_DISC) - Number(discVal) > 0
          ? Number(data.ASK_DISC) - Number(discVal)
          : 0,
    }));
    // console.log(stoneWithUpdate);
    setStoneresultdata(
      [...StoneDataWitout, ...stoneWithUpdate].sort((a, b) => b.STONE - a.STONE)
    );
    // setSelectedStone();
    // Do something with the selected rows (in this case, log them)
  };

  return (
    <>
      {SelectedStone && SelectedStone.length > 0 && (
        <Stack
          direction={"row"}
          flexWrap={"nowrap"}
          overflow={"auto"}
          divider={<Divider orientation="vertical" flexItem />}
          spacing={2}
          sx={{ mb: 1, textWrap: "nowrap", py: 2 }}
        >
          <Item>Pcs = {selectedStoneDetails.pcs || 0}</Item>
          <Item>CTS = {selectedStoneDetails.cts?.toFixed(2) || 0.0}</Item>
          <Item>Rap = {selectedStoneDetails.rap.toFixed(2) || 0}</Item>
          <Item>Disc% = {selectedStoneDetails.disc?.toFixed(2) || 0}</Item>
          <Item>Price = {selectedStoneDetails.price?.toFixed(2) || 0}</Item>
          <Item>Amt ($) = {selectedStoneDetails.amt?.toFixed(2) || 0}</Item>
          <div style={{ marginLeft: "auto" }}>
            <Stack direction="row" spacing={2}>
              <TextField
                fullWidth
                size="small"
                name="Disc"
                label="Disc %"
                onChange={(e) => setDiscVal(e.target.value)}
                sx={{ minWidth: 150, ml: 1 }}
                type="number"
              />
              <Button
                variant="outlined"
                disabled={discVal == null}
                onClick={DiscountStoneHandler}
                color="primary"
              >
                DISC
              </Button>
            </Stack>
          </div>
        </Stack>
      )}
      <Paper title="Single result" sx={{ overflow: "auto" }}>
        <div
          style={{ height: "80vh", minWidth: isMobile ? "1800px" : "1300px" }}
        >
          {Stoneresultdata == null ? (
            <TableSkeleton cols={22} row={11} />
          ) : Stoneresultdata.length > 0 ? (
            <DataGrid
              rows={Stoneresultdata || []}
              columns={columns}
              checkboxSelection
              rowSelectionModel={SelectedStone}
              onRowSelectionModelChange={handleSelectionModelChange}
              density="compact"
              getRowId={(row) => row.STONE}
              //onPa
              // onPageChange={(newPage) => {
              //   console.log("newPage", newPage);
              // }}
              onPaginationModelChange={handlePageSizeChange}
              // onPageSizeChange={(params) =>  console.log(params)
              //   // handlePageSizeChange(params.pageSize)
              // }
              //onPageSizeChange={handlePageSizeChange}
              pageSizeOptions={[50, 100]}
              pagination
              page={page}
              pageSize={pageSize}
              rowCount={rowCount}
              loading={loading}
              paginationMode="server"
              // components={{
              //   LoadingOverlay: CircularProgress,
              // }}
              stickyHeader
            />
          ) : (
            <NoDataPlaceholder />
          )}{" "}
        </div>
      </Paper>
    </>
  );
};

export default StoneTableViewWithAGRFormat;
